module.exports = __webpack_public_path__ + "img/1440.1f1a6489.jpg";